import { useEffect, useState } from 'react';
import { partyApi, type Party } from '../api';

export default function Parties() {
  const [parties, setParties] = useState<Party[]>([]);
  const [q, setQ] = useState('');

  const load = () => partyApi.list(q || undefined).then((r) => setParties(r.parties)).catch(() => null);
  useEffect(() => { load(); /* eslint-disable-next-line */ }, []);

  return (
    <div className="stack">
      <h1>Parties</h1>
      <div className="row">
        <input className="grow" placeholder="Search parties…" value={q} onChange={(e) => setQ(e.target.value)} />
        <button onClick={load}>Search</button>
      </div>
      <div className="card">
        {parties.length === 0 ? <p className="muted">No parties yet.</p> : (
          <table>
            <thead><tr><th>Name</th><th>Type</th><th>Email</th><th>Phone</th></tr></thead>
            <tbody>
              {parties.map((p) => (
                <tr key={p.ROWID}>
                  <td>{p.display_name}</td>
                  <td>{p.entity_type}</td>
                  <td>{p.email || '—'}</td>
                  <td>{p.phone || '—'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
